import { useEffect } from 'react';
import { useUserStore } from 'src/store/user-store';
import { useGenerateSiteSearchKey } from './use-generate-site-search-key';

export const useMeilisearchApiKey = (enabled: boolean = true) => {
  const meilisearchToken = useUserStore().meilisearchToken;
  const setMeilisearchToken = useUserStore().setMeilisearchToken;
  const viewContext = useUserStore().viewContext;

  const { data: newMeilisearchSiteToken } = useGenerateSiteSearchKey(
    viewContext === 'site' && enabled,
  );

  useEffect(() => {
    if (viewContext === 'site') {
      if (
        newMeilisearchSiteToken &&
        newMeilisearchSiteToken !== meilisearchToken
      ) {
        setMeilisearchToken(newMeilisearchSiteToken);
      }
    }
  }, [
    meilisearchToken,
    newMeilisearchSiteToken,
    setMeilisearchToken,
    viewContext,
  ]);
};
